import { render, staticRenderFns } from "./ClaimsGuideTiga.vue?vue&type=template&id=7203e8ef&"
import script from "./ClaimsGuideTiga.vue?vue&type=script&lang=js&"
export * from "./ClaimsGuideTiga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports